import { DoppelTag } from '@/components/shared/doppel_tag'

export function DetectionAssetType({ detectionAsset }) {
  return <DoppelTag tag={detectionAsset.type} width="fit-content" />
}
